import React, { useEffect, useState } from "react";
import Medications from '../../../../globalcomponents/patient360/medicalhistory/medications'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const PatientMedications = (props) => {
  return (
    <>
      <Medications data={props.formValues.patientdata} app="Patient" />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(PatientMedications));


